/* global FB */

import React, { useState } from 'react';
import Parse from '@saucey/parse-js-custom';
import { connect } from 'react-redux';
import { fbLoggedIn } from 'components/login/actions';
import FacebookButton from 'scy/buttons/FacebookButton';
import { trackNow } from 'shared/models/analytic';

function FacebookBtn({
  fbLoggedIn,
  onLoading,
  onComplete,
  onLogin,
  onError,
  promoCode,
  text,
  className
}) {
  const [loading, setLoading] = useState(false);

  function error(user, error) {
    setLoading(false);
    console.log(error); // eslint-disable-line no-console
    let parseError;
    if (error.code === Parse.Error.INVALID_SESSION_TOKEN) {
      Parse.User.logOut();
      parseError = { message: 'Login failed. Please try again' };
    }
    if (onError) onError(parseError || error);
    trackNow('Login Failed', {
      accountType: 'Facebook',
      reason: error.message
    });
  }

  function success(user) {
    if (user.existed()) {
      trackNow('Login', { accountType: 'Facebook' });
      return fbLoggedIn(user).then(() => {
        if (onLogin) return onLogin(user);
        return window.location.reload();
      });
    } else {
      register(user)
        .then(user => {
          trackNow('Registration', { accountType: 'Facebook', promoCode });
          fbLoggedIn(user, true).then(() => onComplete(user));
        })
        .catch(error => {
          console.log(error); // eslint-disable-line no-console
          trackNow('Registration Failed', {
            accountType: 'Facebook',
            reason: error.message
          });
        });
    }
  }

  function register(user) {
    return new Promise((resolve, reject) => {
      FB.api('/me?fields=first_name,last_name,email,gender,birthday', function({
        error,
        first_name,
        last_name,
        email,
        gender,
        birthday,
        id
      }) {
        if (error) return reject(error); // eslint-disable-line no-console
        user.set('firstname', first_name);
        user.set('lastname', last_name);
        user.set('email', email);
        user.set('gender', gender);
        user.set('birthday', birthday);
        user.set('fbID', id);
        user.set(
          'fbAvatarURL',
          `https://graph.facebook.com/${id}/picture?type=square&return_ssl_resources=1`
        );
        user.set('signup_platform', 'web');
        return user
          .save()
          .then(user => resolve(user))
          .catch(err => reject(err));
      });
    });
  }

  function fbLogin() {
    setLoading(true);
    if (onLoading) onLoading();
    Parse.FacebookUtils.logIn(
      'public_profile,email,user_birthday,user_location',
      { error, success }
    );
  }

  return (
    <FacebookButton className={className} onClick={fbLogin} disabled={loading}>
      {text ? text : 'Continue with Facebook'}
    </FacebookButton>
  );
}

function mapStateToProps() {
  return {};
}

export default connect(
  mapStateToProps,
  { fbLoggedIn }
)(FacebookBtn);
